import { useEffect } from "react";
import { toast } from "react-toastify";
import { useQuery } from "react-query";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import RequestSummaryCards from "../../../../components/common/RequestSummaryCards";
import {
	getAllKycUpdateRequestSummaryIndividual,
	getAllKycUpdateRequestSummaryCorporate,
} from "../../../../services/admin";

const Dashboard = () => {
	const {
		data: individualSummary = {},
		isLoading: individualSummaryLoading,
		isError: individualSummaryError,
		error: individualSummaryErrorMessage,
	} = useQuery(
		["get-kycUpdateSummaryIndividual"],
		async () => getAllKycUpdateRequestSummaryIndividual(),
		{
			select: (data) => data.data,
			staleTime: 4 * 60 * 1000,
		}
	);

	const {
		data: corporateSummary = {},
		isLoading: corporateSummaryLoading,
		isError: corporateSummaryError,
		error: corporateSummaryErrorMessage,
	} = useQuery(
		["get-kycUpdateSummaryCorporate"],
		async () => getAllKycUpdateRequestSummaryCorporate(),
		{
			select: (data) => data.data,
			staleTime: 4 * 60 * 1000,
		}
	);

	useEffect(() => {
		if (individualSummaryError) {
			if (individualSummaryErrorMessage.response) {
				toast.error(individualSummaryErrorMessage.response.data?.message);
			} else if (individualSummaryErrorMessage.request) {
				toast.error("Internal Server Error");
			} else {
				toast.error("Error", individualSummaryErrorMessage.message);
			}
		}
		if (corporateSummaryError) {
			if (corporateSummaryErrorMessage.response) {
				toast.error(corporateSummaryErrorMessage.response.data?.message);
			} else if (corporateSummaryErrorMessage.request) {
				toast.error("Internal Server Error");
			} else {
				toast.error("Error", corporateSummaryErrorMessage.message);
			}
		}
	}, [
		individualSummaryError,
		individualSummaryErrorMessage,
		corporateSummaryError,
		corporateSummaryErrorMessage,
	]);

	return (
		<Box sx={{ padding: { md: "2rem", xs: "1rem" } }}>
			<RequestSummaryCards
				requestSummary={individualSummary}
				summaryLoading={individualSummaryLoading}
				title="Individual Accounts"
			/>
			<Divider sx={{ margin: "1rem 0.5rem" }} />
			<RequestSummaryCards
				requestSummary={corporateSummary}
				summaryLoading={corporateSummaryLoading}
				title="Corporate Accounts"
			/>
		</Box>
	);
};

export default Dashboard;
